export const BOARD_EDITORS_LOAD = 'BOARD_EDITORS_LOAD';
